import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyA_0MGQUcg3Bo81VS8m9v7GtgU2vvmoMz8",
    authDomain: "linkedin-clone-f9fba.firebaseapp.com",
    projectId: "linkedin-clone-f9fba",
    storageBucket: "linkedin-clone-f9fba.appspot.com",
    messagingSenderId: "808689459168",
    appId: "1:808689459168:web:e9ab096b446a9acb2d1585",
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();

  export {db,auth};